import React from "react";
import { Form, SmartFormField, SubmitButton } from "../ui/Form";
import { feedbackSchema } from "../../schemas/feedbackSchema";

const FeedbackForm = ({ onSubmit }) => {
  const handleSubmit = async (data) => {
    await onSubmit(data.feedback);
  };

  return (
    <div className="mt-4 m-4">
      <Form
        schema={feedbackSchema}
        onSubmit={handleSubmit}
        defaultValues={{ feedback: "" }}
        className="space-y-2 w-96"
      >
        <SmartFormField
          name="feedback"
          type="textarea"
          inputProps={{
            placeholder: "We'd love to hear your pain, so we can help solve it",
            rows: 5,
            className: "rounded-2xl"
          }}

        />

        <SubmitButton
          variant="danger"
          rounded="full"
          className="px-4"
        >
          Submit Feedback
        </SubmitButton>
      </Form>
    </div>
  );
};

export default FeedbackForm;
